import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { hostedVideoSelectors } from '../../../../store/modules/hostedVideo';

const useManifestSources = () => {
  const [hasSources, setHasSources] = useState(false);
  const manifest = useSelector(hostedVideoSelectors.selectManifest);

  useEffect(() => {
    if (!manifest) return;

    setHasSources(!!manifest?.main.filter(file => file.type === 'video').length);
  }, [manifest]);

  return hasSources;
};

export default useManifestSources;
